import { useQuery } from "@tanstack/react-query";
import Cookies from "js-cookie";
import { useMemo } from "react";
import { useParams } from "react-router-dom";

import { useEmpLoanModal } from "./use-loan-modal";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog/dialog";
import { getAllLoanOfEmployeeByAdminQueryOptions } from "@/config/queries/query-options";
import { columns } from "./loan-table/columns";
import { DataTable } from "./loan-table/data-table";

export const EmployeeLoanModal = () => {
  const { empId } = useParams() as {
    empId: string;
  };

  const key = Cookies.get("key") as string;
  const { open, onOpenChange } = useEmpLoanModal();

  const { data, isPending, isFetching } = useQuery(
    getAllLoanOfEmployeeByAdminQueryOptions(key, {
      employee: empId,
      status: "Approved",
    })
  );

  const loanRequestsData = useMemo(() => {
    if (isPending) {
      return [];
    }

    if (data === undefined || data?.loans === undefined) {
      return [];
    }

    const result = data?.loans?.map((la) => {
      return {
        id: la?._id,
        totalAmountRequested: la?.totalAmountRequested,
        totalAmountApproved: la?.totalAmountApproved,
        remainingBalance: la?.remainingBalance?.toFixed(2),
        status: la?.status,
        employeeName: la?.employeeId?.name,
        employeeEmail: la?.employeeId?.email,
        createdAt: la?.createdAtIST,
      };
    });

    return result?.sort(
      (a, b) =>
        new Date(b?.createdAt).getTime() - new Date(a?.createdAt).getTime()
    );
  }, [isPending, isFetching, data]);

  return (
    <>
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="max-w-5xl overflow-y-scroll max-h-[580px]">
          <DialogHeader>
            <DialogTitle>Employee Approved Loan</DialogTitle>
          </DialogHeader>

          <div className="mt-5">
            <DataTable data={loanRequestsData} columns={columns} />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
